module.exports = __webpack_public_path__ + "static/media/devops-azure-img-black.6fcfb73b.png";